import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import * as service from '../../../services/inquiryEmailTemplate.service';
import CustomPagination from '../../../common/custompagination';
import Breadcrums from '../../../common/breadcrumbs';
import { SWAL_SETTINGS, THEME_COLORS } from '../../../../../utils/Constants';
import { formateDateWithMonth, handleServerValidations, TrimText } from '../../../../../utils/commonfunction';
import { Placeholder, Tooltip, Whisper } from 'rsuite';

const InquiryEmailTemplateList = () => {
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [statsupdate, setStatusUpdate] = useState(false);
  const [datalength, setDataLength] = useState('');
  const [itemperpage] = useState(10);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [globalsearch, setGlobalSearch] = useState('');

  const breadcrumbs = [
    { title: 'Dashboard', url: '/admin/dashboard' },
    { title: 'CMS', url: '' },
    { title: 'Inquiry Email Templates', url: '' },
  ];

  useEffect(() => {
    setLoader(true);
    const fd = new FormData();
    fd.append('page', params.pgno);
    fd.append('per_page', itemperpage);
    fd.append('global_search', globalsearch);
    service.List(fd).then(data => {
      setDataLength(data.data.total_records);
      setList(data?.data?.list || []);
      setPage(data?.data?.page || 1);
      setLoader(false);
    }).catch(() => setLoader(false));
  }, [location, statsupdate, globalsearch, params.pgno]);

  const handleDelete = (row) => {
    Swal.fire({
      customClass: 'swal-wide', title: 'Are you sure?', icon: 'warning',
      showCancelButton: true, confirmButtonColor: THEME_COLORS.ADMIN_PRIMARY,
      cancelButtonColor: '#000', confirmButtonText: 'Yes, delete it!',
    }).then(result => {
      if (result.isConfirmed) {
        const fd = new FormData();
        fd.append('o_id', JSON.stringify([row._id]));
        service.Delete(fd).then(res => {
          setStatusUpdate(!statsupdate);
          Swal.fire({ icon: res.success ? 'success' : 'error', text: res.message, ...SWAL_SETTINGS });
        });
      }
    });
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">Inquiry Email Templates</h6>
              <div className="d-flex align-items-center">
                <div className="form-group mb-0 me-3">
                  <div className="form-group mb-0 rangepicker_container filter_design">
                    <i className="fa fa-search calender_icon"></i>
                    <input type="search" className="form-control" value={globalsearch}
                      placeholder="Search" onChange={e => setGlobalSearch(e.target.value)} />
                  </div>
                </div>
                <button className="btn ripple btn-main-primary signbtn ms-2"
                  onClick={() => navigate('/admin/cms/inquiry-email-templates/add')}>
                  Add New
                </button>
              </div>
            </div>

            {loader ? (
              <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={30} rowSpacing={5} active rows={7} />
            ) : (
              <>
                <div className="table-responsive min-h-400">
                  <table className="table table-bordered card-table border-top text-nowrap w-100">
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Title</th>
                        <th>Subject</th>
                        <th>Created Date</th>
                        <th className="action_head">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {list.length ? list.map((row, i) => (
                        <tr key={i}>
                          <td>{(page - 1) * itemperpage + i + 1}</td>
                          <td>{TrimText(row.title, 30) || 'N/A'}</td>
                          <td>{TrimText(row.subject, 40) || 'N/A'}</td>
                          <td>{row.createdAt ? formateDateWithMonth(row.createdAt) : 'N/A'}</td>
                          <td>
                            <div className="btn-toolbar table-actions">
                              <div className="btn-group btn-group-sm">
                                <Whisper placement="top" trigger="hover" speaker={<Tooltip style={{ fontWeight: 'bold' }}>Edit</Tooltip>}>
                                  <button type="button" className="btn edit"
                                    onClick={() => navigate(`/admin/cms/inquiry-email-templates/edit/${row._id}`)}>
                                    <i className="ri-pencil-fill"></i>
                                  </button>
                                </Whisper>
                                <Whisper placement="top" trigger="hover" speaker={<Tooltip style={{ fontWeight: 'bold' }}>Delete</Tooltip>}>
                                  <button type="button" className="btn delete" onClick={() => handleDelete(row)}>
                                    <i className="ri-delete-bin-6-fill"></i>
                                  </button>
                                </Whisper>
                              </div>
                            </div>
                          </td>
                        </tr>
                      )) : (
                        <tr><td colSpan={5} className="text-center">No records found</td></tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <div><b>Total Records: {datalength || 0}</b></div>
                {datalength > 0 && (
                  <CustomPagination datalength={datalength} itemperpage={itemperpage}
                    currentPage={page} setPage={setPage}
                    pageRoute={[{ name: 'inquiry-email-templates', path: '/admin/cms/inquiry-email-templates/list' }]} />
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default InquiryEmailTemplateList;
